module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-cwComboBoxView2__content input-group flex-nowrap phx-list-builder-wrap">\r\n  <input type="text" class="c-cwComboBoxView2__input form-control" autocomplete="off">\r\n  <div class="input-group-append">\r\n    <div class="input-group-text c-cwComboBoxView2__icon"></div>\r\n  </div>\r\n</div>\r\n';
}
return __p;
};
